import { TLCEventManager } from "../../../../js/lib/events/EventManager";
import { TLCRest } from "../../../../js/lib/rest/REST";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";
import { PACStandardNumberUtil } from "../utils/PACStandardNumberUtil";

export const TeachingBooksClientManager = (function() {

  TLCEventManager.addListener(LS2PAC_CONSTANTS.Events.onTeachingBooksButtonClick, function(event) {
    TLCRest.jsonCall("teachingBooks/formData/" + event.tid, {
      callback: event.callbackFunc
    });
  });

  return {
    getTeachingBooksTitleId: function(resource, callbackFunc) {
      var isbns = PACStandardNumberUtil.getStandardNumbersByType(resource.standardNumbers, 'Isbn');
      if (isbns != null && isbns.length > 0) {
        var opts = {
          callback: callbackFunc,
          postData: isbns
        };

        TLCRest.jsonCall("teachingBooks/titleId", opts);
      }
    }
  }

})();
